var map = {
	"./2-card-teenpatti.webp": 36257,
	"./24-help-line.webp": 5701,
	"./247-customer-support.webp": 10122,
	"./29-card.webp": 9162,
	"./3-card.webp": 2491,
	"./3-patti-2020.webp": 44261,
	"./300%-bouns.webp": 17067,
	"./30games.webp": 20894,
	"./32-card-casino.webp": 36662,
	"./32-cards-live-card.webp": 98109,
	"./3d-cube.webp": 73794,
	"./404-not-found.webp": 46558,
	"./5%back.webp": 28237,
	"./7up7down-live-card.webp": 2169,
	"./7up7down-menu.webp": 67121,
	"./7up7down.webp": 50974,
	"./Affiliate-white.1039a38.webp": 84206,
	"./Baccarat.webp": 51237,
	"./Blackjack.webp": 86958,
	"./Blue-icon.webp": 34264,
	"./Deposit_Now_Icon.webp": 52849,
	"./Download-App (2).webp": 23270,
	"./Download-app-Images.c7b8e56.webp": 88517,
	"./Game Shows.webp": 37054,
	"./GiftImg.webp": 45877,
	"./Gold-icon.webp": 791,
	"./Instant-Withdrawals.webp": 33160,
	"./Lucknow_Super_Giants.webp": 15978,
	"./MI.webp": 93125,
	"./Platinum-icon.webp": 96453,
	"./Poker.webp": 54971,
	"./Roulette.webp": 97856,
	"./Silver-icon.webp": 34579,
	"./Slot-game.webp": 40258,
	"./Whatsapp12.webp": 36035,
	"./aaa-live-card.webp": 90512,
	"./about-us-icons.webp": 11549,
	"./about-us-white.webp": 22523,
	"./about-us.webp": 94295,
	"./add.webp": 95589,
	"./affiliate.webp": 52025,
	"./aggle-open.webp": 75701,
	"./amar-akbar-anthony.webp": 22310,
	"./amar-akbar.webp": 44025,
	"./andar-bahar.webp": 69596,
	"./andar_bahar-live-card.webp": 94205,
	"./android-apk-img.webp": 53232,
	"./android-down.webp": 6226,
	"./angle-right-solid.webp": 27135,
	"./announcement-icon.webp": 38915,
	"./apk-modal-icon.webp": 17348,
	"./app.webp": 80126,
	"./arow-down.webp": 59373,
	"./arrow-right-icon.webp": 84073,
	"./asia-gaming-provider.webp": 40915,
	"./astropay.webp": 97015,
	"./auto-roulette-img.webp": 73162,
	"./avatar-ux-provider.webp": 52304,
	"./avatarux-provider.webp": 36363,
	"./avtar.webp": 47961,
	"./bac.webp": 61690,
	"./back-arrow.webp": 73123,
	"./back.webp": 8553,
	"./badminton.webp": 13591,
	"./ballimg.webp": 46571,
	"./bank-deposit.webp": 16583,
	"./bank-img.webp": 83659,
	"./bank.webp": 77414,
	"./banner-1.webp": 62554,
	"./banner-2.webp": 26051,
	"./banner-3.webp": 92621,
	"./banner-4.webp": 39192,
	"./baseball.webp": 41866,
	"./basket.webp": 40131,
	"./bcoongo.webp": 97799,
	"./bet-games-provider.webp": 4336,
	"./bet-games-tv-provider.webp": 32653,
	"./bet-games.webp": 14748,
	"./bet-info-icon.webp": 33236,
	"./bet-soft.webp": 66067,
	"./beter-live-provider.webp": 28899,
	"./betgames-provider.webp": 58546,
	"./betgames-tv-provider.webp": 71663,
	"./betsoft-provider.webp": 30369,
	"./betting.webp": 12820,
	"./bgaming-provider.webp": 16591,
	"./big-time-gaming-provider.webp": 67670,
	"./bitcoin.webp": 38605,
	"./blueprint-gaming-provider.webp": 2984,
	"./bombay-live-provider.webp": 54597,
	"./bonus-bg.webp": 50994,
	"./book_24x7_icon.webp": 84466,
	"./book_goldtier_icon.webp": 21507,
	"./book_withdrawal_icon.webp": 29986,
	"./box-icon.webp": 82896,
	"./boxing.webp": 47984,
	"./brand-ambass-desktop.webp": 20578,
	"./brand-ambass-mobile.webp": 25542,
	"./calendar-data.webp": 44090,
	"./calendar.webp": 35473,
	"./caleta-gaming-provider.webp": 8779,
	"./cashout-icon.webp": 50943,
	"./casino-icon.webp": 62430,
	"./casino-live.webp": 22230,
	"./casino.webp": 92219,
	"./change_no_white.webp": 4019,
	"./chat-close.webp": 29397,
	"./chat-icon.webp": 76550,
	"./chat.webp": 34355,
	"./check-mark.webp": 28518,
	"./chip.webp": 91981,
	"./ck-lang-icon.webp": 51560,
	"./clock-icon.webp": 12674,
	"./clock.webp": 7687,
	"./close (2).webp": 94394,
	"./close-btn.webp": 29482,
	"./close-language.webp": 21133,
	"./close.webp": 8149,
	"./closeButton.webp": 49561,
	"./club-logo.webp": 54490,
	"./code.webp": 42847,
	"./coming-soon-desktop.3189a38.webp": 25103,
	"./comment (1).webp": 13830,
	"./comment.webp": 87967,
	"./copy-icon.webp": 8200,
	"./counter-strike.webp": 44739,
	"./crash-img.webp": 15808,
	"./crash88-gaming-provider.webp": 49317,
	"./crazy-time.webp": 87062,
	"./credit-card.webp": 8821,
	"./creedroomz-provider.webp": 14147,
	"./cricket-fall.webp": 31793,
	"./cricket-lambi.webp": 45563,
	"./cricket-odds.webp": 93136,
	"./cricket-over.webp": 13835,
	"./cricket-runs.webp": 43225,
	"./cricket.5c05f66.webp": 17713,
	"./cricket.webp": 87412,
	"./cross-button.webp": 37977,
	"./cross-icon.webp": 90749,
	"./crypto.webp": 41787,
	"./customer-support.webp": 82033,
	"./deal-no-deal.webp": 73514,
	"./delete.webp": 78811,
	"./deposit-video-banner.webp": 74861,
	"./desktop-live-casino-banner.webp": 84952,
	"./doge_small_icon.webp": 35830,
	"./dollar-icon.webp": 69456,
	"./dot-icon.webp": 20086,
	"./dota.webp": 22644,
	"./down-arrow.webp": 78874,
	"./down-sel.webp": 78104,
	"./down.webp": 75056,
	"./download (2) (1).webp": 68301,
	"./download-app.webp": 70785,
	"./download.webp": 25017,
	"./dragon-tiger.webp": 34555,
	"./dragon_tiger-live-card.webp": 58683,
	"./easy-accessible-efficient.webp": 16826,
	"./edit-icon.webp": 83958,
	"./editing.webp": 38540,
	"./election.webp": 98110,
	"./email.webp": 67196,
	"./ethereum.webp": 42200,
	"./evolution-banner.webp": 29447,
	"./evolution-gaming-provider.webp": 79907,
	"./evolution-gaming.webp": 92250,
	"./evolution-provider.webp": 72671,
	"./evoplay-entertainment-provider.webp": 45896,
	"./exit-clickbet-bg.webp": 11589,
	"./exit-clickbet-icon.webp": 79804,
	"./eye-icons.webp": 72118,
	"./eye-open.webp": 33608,
	"./ezugi-provider.webp": 37567,
	"./ezugi.webp": 1689,
	"./facebook-share.webp": 56614,
	"./facebook.webp": 25299,
	"./fair-play-icons.webp": 63327,
	"./fair-ply-betting-bg.webp": 22937,
	"./fairplay-book-Logo.webp": 23012,
	"./fairplay-book-desktop.webp": 51524,
	"./fairplay-book-mobile.webp": 3107,
	"./fancy-green-icon.webp": 75256,
	"./fantasma-provider.webp": 17398,
	"./fantasy-crci-icon.webp": 22182,
	"./fantasybookicon.225b8cb.webp": 92964,
	"./faqs.2cdc688.webp": 299,
	"./faqs.webp": 49606,
	"./fast.webp": 99811,
	"./favo-star.webp": 49151,
	"./favorites.webp": 81268,
	"./fc_logo.webp": 89419,
	"./fifa.webp": 76672,
	"./fighting.webp": 75359,
	"./file-icon.webp": 50137,
	"./filter-icon.webp": 76613,
	"./flag-1.webp": 96310,
	"./flag-2.webp": 8316,
	"./flag-3.webp": 8340,
	"./flighting.webp": 16300,
	"./formula-1.webp": 74721,
	"./game-1.webp": 10968,
	"./game-10.webp": 37411,
	"./game-11.webp": 25647,
	"./game-12.webp": 64439,
	"./game-13.webp": 37748,
	"./game-14.webp": 28233,
	"./game-15.webp": 62625,
	"./game-16.webp": 54962,
	"./game-17.webp": 67764,
	"./game-18.webp": 75557,
	"./game-19.webp": 94163,
	"./game-20.webp": 908,
	"./game-21.webp": 18400,
	"./game-22.webp": 32609,
	"./game-23.webp": 4419,
	"./game-24.webp": 8364,
	"./game-25.webp": 57475,
	"./game-26.webp": 59423,
	"./game-27.webp": 91475,
	"./game-28.webp": 33207,
	"./game-3.webp": 90380,
	"./game-30.webp": 34928,
	"./game-4.webp": 83538,
	"./game-5.webp": 4418,
	"./game-6.webp": 50218,
	"./game-7.webp": 39580,
	"./game-8.webp": 63018,
	"./game2.webp": 42701,
	"./gamzix-provider.webp": 90669,
	"./gc.webp": 64700,
	"./gift-box.webp": 3279,
	"./gift-icon.webp": 2010,
	"./global-casino-provider.webp": 82774,
	"./global-network.webp": 43986,
	"./gold-pot.webp": 61388,
	"./golden-race-provider.webp": 35762,
	"./golf.webp": 65869,
	"./google-pay.webp": 61755,
	"./google.webp": 11246,
	"./gpay.webp": 44169,
	"./green-tick.webp": 89429,
	"./greyhound.webp": 14382,
	"./habanero-provider.webp": 12272,
	"./hacksaw-gaming-provider.webp": 26707,
	"./hefty-commissions.webp": 99169,
	"./help.webp": 83362,
	"./hi-lo.webp": 52277,
	"./home-icon.webp": 7784,
	"./horse-img1.webp": 87672,
	"./horse-img2.webp": 99189,
	"./horse-img3.webp": 46394,
	"./horse-img4.webp": 39575,
	"./horse-race-icon.webp": 18860,
	"./horse.webp": 10346,
	"./hotspot.webp": 59650,
	"./i-fream.webp": 35163,
	"./ibetsoft.webp": 81683,
	"./icc-world.webp": 41219,
	"./icon.webp": 83195,
	"./iconpe-live-cards.webp": 80907,
	"./iconpe-live-casino.webp": 20645,
	"./iconpe-sportsbook.webp": 32589,
	"./info-icon.webp": 45353,
	"./info.webp": 64559,
	"./inplay.a7c4dae.webp": 97257,
	"./inplay_bg.webp": 70225,
	"./inplayico (1).webp": 51286,
	"./inplayico.40798d4.webp": 96289,
	"./inplayico.webp": 26767,
	"./instagram (1).webp": 82056,
	"./instagram-share.webp": 36006,
	"./instagram.webp": 59246,
	"./ios-apk-img.webp": 13703,
	"./jdb-gaming-provider.webp": 58573,
	"./jili-gaming-provider.webp": 96647,
	"./jili-provider.webp": 41845,
	"./kalamba-games-provider.webp": 66549,
	"./key-chain.webp": 35873,
	"./key.webp": 44800,
	"./kingmaker-provider.webp": 82011,
	"./kingmidas-games-provider.webp": 99178,
	"./kingmidas-gaming-provider.webp": 70789,
	"./kingmidas-provider.webp": 81292,
	"./know-more-img-1.webp": 33096,
	"./know-more-img-2.webp": 21364,
	"./know-more-img-3.webp": 94260,
	"./know-more-img-4.webp": 86435,
	"./know-more-img-5.webp": 79296,
	"./know-more-img-6.webp": 67139,
	"./leagues-img.webp": 29232,
	"./left-blue.webp": 82880,
	"./left-gold.webp": 68663,
	"./lightning-dice.webp": 2379,
	"./linkedin-share.webp": 74280,
	"./linkedin.webp": 8756,
	"./live-card-img-1.webp": 81158,
	"./live-card-img-2.webp": 48313,
	"./live-card-img-3.webp": 17433,
	"./live-card-img-4.webp": 18318,
	"./live-card.c981209.webp": 40718,
	"./live-cards-banner.webp": 92608,
	"./live-cards.webp": 89344,
	"./live-casino-1.webp": 91952,
	"./live-casino-2.webp": 83609,
	"./live-casino-3.webp": 502,
	"./live-casino-4.webp": 15895,
	"./live-casino-banner-rgt.webp": 81954,
	"./live-casino-banner.webp": 12026,
	"./live-casino-mobile-1.webp": 44302,
	"./live-casino-mobile-2.webp": 65514,
	"./live-casino-mobile-3.webp": 90889,
	"./live-casino-mobile.webp": 47825,
	"./live-casino.761f895.webp": 88956,
	"./live-casino.webp": 26955,
	"./live-stram.webp": 9892,
	"./live-tv.webp": 6600,
	"./live88-provider.webp": 86877,
	"./login-background.webp": 47655,
	"./login.webp": 94212,
	"./logo_48.webp": 11905,
	"./logout_icon.webp": 25432,
	"./loss-icon.webp": 49187,
	"./loyalty.2af5a05.webp": 49706,
	"./loyalty.webp": 7514,
	"./ltc_small_icon.webp": 75825,
	"./madhur-img.webp": 26032,
	"./manage-ID.webp": 2987,
	"./market-logo.webp": 52222,
	"./market.fa9c382.webp": 48410,
	"./market.webp": 75234,
	"./marketing-icon.webp": 19588,
	"./matka-pot-icon.webp": 19855,
	"./matka-time-icon.webp": 27891,
	"./matka.webp": 36956,
	"./megaphone.webp": 34695,
	"./member-border-arrow-right.webp": 41640,
	"./member-border-arrow.webp": 21683,
	"./member-border-bottom.webp": 43965,
	"./menu-2378961.webp": 74902,
	"./menu-7.webp": 56140,
	"./menu-dots.webp": 76698,
	"./menu-icon.webp": 97384,
	"./menu-toggle.webp": 85883,
	"./menu.webp": 87449,
	"./messenger (1).webp": 86724,
	"./messenger.webp": 43020,
	"./microgaming.webp": 94108,
	"./min-max-icon-bacup.webp": 25453,
	"./minus-icon.webp": 88739,
	"./minus.webp": 50578,
	"./mobile-promo-img-2.webp": 53440,
	"./modal-info-icon.webp": 44924,
	"./money-wheel.webp": 96940,
	"./money.webp": 15616,
	"./monk88-provider.webp": 97453,
	"./multitier-system.webp": 46796,
	"./my-IDs.webp": 89636,
	"./news.02d7854.webp": 95292,
	"./news.webp": 95179,
	"./no-data-img.webp": 74215,
	"./notification.webp": 96691,
	"./offer-desktop.webp": 66319,
	"./offerings.webp": 62140,
	"./offers.webp": 94952,
	"./onetouch-provider.webp": 61955,
	"./online-betting-app.6c7409d.webp": 61117,
	"./online-betting-app.webp": 12854,
	"./open-bets.webp": 65322,
	"./open_bets.webp": 51594,
	"./others.webp": 24937,
	"./pascal-provider.webp": 72777,
	"./password-icon.webp": 37972,
	"./payment-img.webp": 79278,
	"./paypal.webp": 2444,
	"./paytm.webp": 97168,
	"./pgsoft.webp": 53944,
	"./phone-call.webp": 67312,
	"./phonepe-img.webp": 53690,
	"./phonepe.webp": 70897,
	"./placedbetimg2.webp": 66070,
	"./play'n-go-provider.webp": 58567,
	"./playson-provider.webp": 76996,
	"./playtech-live-provider.webp": 53289,
	"./playtech-provider.webp": 88478,
	"./plus-icon.webp": 36348,
	"./plus.webp": 31103,
	"./poker-live-card.webp": 70129,
	"./poker1.webp": 38550,
	"./popok-gaming-provider.webp": 23238,
	"./popok-instant-provider.webp": 40931,
	"./premium-notebook.cfec1a1.webp": 33465,
	"./premium1.webp": 66472,
	"./privacy-policy.webp": 63858,
	"./privacy.webp": 54802,
	"./pro.webp": 62109,
	"./processing-icon.webp": 90038,
	"./profile.webp": 43429,
	"./project-apk-icon.webp": 25318,
	"./promo-img-1.webp": 70879,
	"./promo-img-2.webp": 67120,
	"./promo-img-3.webp": 80898,
	"./promo-img-4.webp": 38114,
	"./promo-img-5.webp": 18280,
	"./promo-mobile-img-3.webp": 21971,
	"./promo-mobile-img-4.webp": 55418,
	"./promotion-img-1.webp": 57599,
	"./promotion-img-2.webp": 46018,
	"./promotion-img-3.webp": 3713,
	"./promotion-img-4.webp": 12223,
	"./promotion-mobile-img.webp": 32699,
	"./promotions.6cd6774.webp": 42164,
	"./promotions.webp": 69203,
	"./promp-img-5.webp": 13335,
	"./purse.webp": 86319,
	"./qr-code.webp": 47761,
	"./race.webp": 92411,
	"./radio.webp": 66669,
	"./realtime-gaming.webp": 99686,
	"./receipt-img.webp": 5114,
	"./red-close-btn.webp": 63328,
	"./refer-user.webp": 57105,
	"./refer.0ebb210.webp": 67628,
	"./refer.webp": 74388,
	"./referal-bonus.webp": 29158,
	"./refresh.webp": 72448,
	"./register-whatsapp.webp": 49180,
	"./relax-gaming-provider.webp": 26138,
	"./remove-icon.webp": 94822,
	"./request-right-icon.webp": 29365,
	"./reset_password.webp": 28127,
	"./result-img.webp": 10887,
	"./right-icon.webp": 480,
	"./roulette (1).webp": 65007,
	"./royal-gaming-provider.webp": 460,
	"./royal-gaming-virtual-provider.webp": 25060,
	"./rt-provider.webp": 75962,
	"./rubgy.webp": 28500,
	"./rules.webp": 98358,
	"./rupee.webp": 7590,
	"./rupi.webp": 37836,
	"./sa-gaming.webp": 89714,
	"./score-eye.webp": 65564,
	"./score-graph.webp": 30225,
	"./score-hide.webp": 43260,
	"./search-grey-icon.webp": 9136,
	"./settings.webp": 40571,
	"./sexybcrt-provider.webp": 86518,
	"./share.webp": 97720,
	"./slider-desk-1.webp": 61061,
	"./slider-img-1.webp": 54769,
	"./slider-img-2.webp": 65565,
	"./slider-img-3.webp": 10656,
	"./slider-img-4.webp": 26008,
	"./slot-game-1.webp": 40573,
	"./slot-game-2.webp": 81942,
	"./slot-game-3.webp": 27503,
	"./slot-game-4.webp": 47360,
	"./slot-game-5.webp": 62735,
	"./slot-game-6.webp": 26014,
	"./slot-game-7.webp": 84224,
	"./slot-game-8.webp": 44779,
	"./slot-games.ccf3217.webp": 15362,
	"./slotsCasinoPopUp.webp": 76084,
	"./smartsoft-gaming-provider.webp": 8982,
	"./smartsoft-provider.webp": 29583,
	"./soccer-fancy.webp": 94121,
	"./soccer-odds.webp": 42201,
	"./soccer.9f718cc.webp": 70410,
	"./soccer.webp": 97514,
	"./sports.webp": 92982,
	"./sportsbook.5e7a4f5.webp": 483,
	"./sportsradar1.webp": 96426,
	"./spribe-provider.webp": 63234,
	"./star-favorite.webp": 62169,
	"./star.webp": 69864,
	"./statistics.webp": 87627,
	"./stay-up-to-date.webp": 81715,
	"./stormcraft-provider.webp": 23230,
	"./super-spades.webp": 61073,
	"./t20-3-patti.webp": 12787,
	"./tangente-provider.webp": 70813,
	"./teen-patti-1.webp": 10557,
	"./teen-patti_one-day.webp": 85602,
	"./teenpatti.webp": 61894,
	"./telegram-share.webp": 80736,
	"./telegram.webp": 81370,
	"./television.webp": 46254,
	"./tennis-odds.webp": 75998,
	"./tennis.fc30791.webp": 66087,
	"./tennis.webp": 94841,
	"./terms-and-conditions-white.webp": 80707,
	"./terms-and-conditions.ff1e042.webp": 12346,
	"./terms-and-conditions.webp": 2851,
	"./tether.webp": 72137,
	"./time-icon.webp": 83969,
	"./timer-black-icon.webp": 48752,
	"./timer-icon.webp": 97651,
	"./timer.webp": 22754,
	"./top-up-icon.webp": 7038,
	"./transactions.webp": 76552,
	"./turbo-games-provider.webp": 90758,
	"./turbogames-provider.webp": 29176,
	"./tutorial.webp": 66630,
	"./tv-img.webp": 23319,
	"./twitter-share.webp": 34954,
	"./twitter.webp": 75223,
	"./upcoming.webp": 72819,
	"./upcomingico.webp": 13827,
	"./upi.webp": 34757,
	"./user-icon.webp": 88127,
	"./user-wallet-icon.webp": 83269,
	"./userMultiIcon.webp": 60378,
	"./vegas-lounge-casino-provider.webp": 76606,
	"./vegaslounge-provider.webp": 84575,
	"./video-image.webp": 16239,
	"./virtual-sports-img.webp": 61918,
	"./virtual.webp": 50163,
	"./vivo-gaming-provider.webp": 81914,
	"./vivo.webp": 96601,
	"./vivogaming-provider.webp": 6901,
	"./volly.webp": 14515,
	"./wallet-bank.webp": 26129,
	"./wallet-deposit-icon.webp": 19202,
	"./wallet-history.webp": 6718,
	"./wallet-icon.webp": 24812,
	"./wallet-primary.webp": 50332,
	"./wallet-withdraw-icon.webp": 84778,
	"./wallet.webp": 5029,
	"./wazdan-provider.webp": 35390,
	"./website-super-winlogo.webp": 19107,
	"./whatsApp-icon.webp": 93429,
	"./whatsapp-btn-icon.webp": 51439,
	"./whatsapp-share.webp": 46025,
	"./whatsapp.webp": 94098,
	"./winfinity-provider.webp": 71506,
	"./winner-img.webp": 16797,
	"./winners-img.webp": 54027,
	"./winners-user.webp": 48707,
	"./withdrawal.webp": 55999,
	"./world.webp": 86105,
	"./worli-matka-live-card.webp": 9015,
	"./worli-matka.webp": 25834,
	"./wrong-icon.webp": 41104,
	"./xpg1.webp": 59579,
	"./youtube.webp": 4065,
	"./yuvi-games-provider.webp": 61678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15336;